import countriesData from './flameproxy-countries.json';

export interface ProxyCountry {
  code: string;
  name: string;
}

/** Countries available from Flame Proxy, for the proxy-country selector. */
export const PROXY_COUNTRIES: ProxyCountry[] = countriesData;
